export default __webpack_public_path__ + "static/media/close.67a77691.svg";